import React, { useEffect, useCallback } from 'react';
import { SearchBar, SearchkitWrapper } from '@uncinc/react-searchkit';
import { useTranslation } from 'react-i18next';
import { history } from 'instantsearch.js/es/lib/routers';
import { useHistory } from 'react-router';

import './style.scss';

import { SEARCH_PATH, SEARCHKIT_HOST_URL, APP_OPTIONS } from '../../../config/constants';

import {
  searchAttributes,
  resultAttributes,
} from '../config';

interface SearchInputProps {
  setIsSearchOpen?: (isSearchOpen: boolean) => void;
}

const SearchInput = ({ setIsSearchOpen = () => { } }: SearchInputProps) => {
  const { t } = useTranslation();
  const routerHistory = useHistory();
  const inputRef = useCallback((currentRef) => {
    if (currentRef !== null) {
      currentRef.focus();
    }
  }, []);

  const routing = {
    router: history({
      start: (onUpdate) => {
        routerHistory.listen(onUpdate);
      },
      push: (url) => {
        try {
          const { search } = new URL(url);

          if (search) {
            routerHistory.push(`${SEARCH_PATH}${search}`);
          }
        } catch (error) {
          // If the url is invalid, we will just ignore the rest of the function.
          console.error(error);
        }
      },
    }),
  };

  let classNames;
  useEffect(() => {
    const closeSearch = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsSearchOpen(false);
      }
    };

    document.addEventListener('keydown', closeSearch);

    return () => {
      document.removeEventListener('keydown', closeSearch);
    };
  });

  return (
    <div className="SearchInput">
      <div className="SearchInput__input">
        <SearchkitWrapper
          className={classNames}
          connection={{
            host: SEARCHKIT_HOST_URL,
          }}
          routing={routing}
          indexName={APP_OPTIONS.parameters.searchkitIndexAllContent}
          searchSettings={{
            search_attributes: searchAttributes,
            result_attributes: resultAttributes,
          }}
        >
          <SearchBar
            ref={inputRef}
            title={t('components.search.searchbar.label')}
            placeholder={t('components.search.searchbar.placeholder')}
          />
        </SearchkitWrapper>
      </div>
    </div>
  );
};

export default SearchInput;
